import { dictWithUrl } from '@/components/lots/api.js';
/**
 * keyMap形式加载字典
 * @param {Map<string, string>} keyMap Map<key, DictCodeType>
 * @returns Promise<Map<key, Object>>
 * @example
 *  const res = await ({
 *      warningStatus: 'CHANGE_MONITOR_WARNING_STATUS'
 *   })
 */
export async function fetchDictBy(keyMap) {
    const keys = Object.keys(keyMap);
    const codes = keys.map(key => keyMap[key]).filter(Boolean).join(',');
    const dictRes = await dictWithUrl(codes);
    return keys.reduce((acc, key) => {
        const dictKey = keyMap[key];
        acc[key] = dictRes.data[dictKey];
        return acc;
    }, {});
}

/** 获取字典并转为el-select使用的options数组
 * @param {String} code 字典编码
 * @returns Promsise<Array>
 */
export async function getDictOptions(code) {
    const res = await dictWithUrl(code);
    if (+res.code === 0 && res.data) {
        return dictToOptions(res.data[code] || {});
    }
    return [];
};

/**
 * 将字典返回值转为el-select使用的options数组
 * @pararm { Object } dictData 字典球请求返回值对象
 * @returns Array
 */
export function dictToOptions(dictData) {
    const options = [];
    if (dictData) {
        Object.keys(dictData).forEach(val => {
            options.push({
                label: dictData[val],
                value: val
            });
        });
    }
    return options;
}
